import React, { useContext, useState } from 'react'
import { useHttp } from '../../hooks/http.hook'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import { Row, Col, ListGroup, Badge } from 'react-bootstrap';
import { FaSortUp, FaSortDown } from 'react-icons/fa';
import EditableSpan from "../components/EditableSpan";
import { Link } from 'react-router-dom'

export const CardPreviewQuiz = ({ lessonId, experience, updateExperience, setReceivedError }) => {

    const { request, loading } = useHttp()
    const { token, client, role } = useContext(AuthContext)

    let paramId = useParams().id;
    let clientId = (role === 'admin' ? paramId : client);
    let quizData = experience.quiz?.reduce((acc, q) => {
        if (q.client_id) acc.custom_quiz.push(q);
        else acc.quiz.push(q);

        return acc;
    }, {
        quiz: [], custom_quiz: [],
    });

    const [quizName, setQuizName] = useState('')
    const [quizUpdateForm, setQuizUpdateForm] = useState([])

    const updateQuizHandler = (data, key, val) => {
        setQuizUpdateForm(prevQuizUpdateForm => {

            if (prevQuizUpdateForm.some(item => item.id === data.id)) {
                // console.log("Object found inside the array.");
                return prevQuizUpdateForm.map(
                    item => {
                        if (item.id === data.id) {
                            item[key] = val
                        }
                        return item
                    }
                )

            } else {
                console.log("Object not found.");
                return [...quizUpdateForm, key ? { ...data, [key]: val } : data];
            }
        });
    }

    const addCustomQuiz = async () => {
        try {
            const data = await request('/quiz/add', 'POST', {
                name: quizName,
                experienceId: experience.id,
                clientId: clientId, // this is custom flag
                lessonId: lessonId  // this is custom flag
            }, {
                'x-access-token': token
            })

            if (data.quiz) {
                let quiz = experience.quiz;

                if (quiz && quiz.length)
                    quiz = [...quiz, data.quiz[0]]
                else
                    quiz = [data.quiz[0]]

                updateExperience({ ...experience, quiz })
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeCustomQuiz = async (quiz_id) => {
        try {
            let data_form = quizUpdateForm.filter(item => {
                return item.id === quiz_id
            })
            const data = await request(`/quiz/update/${quiz_id}`, 'POST', data_form[0], {
                'x-access-token': token
            })

            if (data.changed === 1) {
                //if request succes - change name
                //console.log('name should be changed');

                const quiz = experience.quiz.map(quiz_item => (
                    quiz_item.id === quiz_id ? { ...quiz_item, name: data_form[0].name } : quiz_item
                ));

                updateExperience({ ...experience, quiz });
            }
            setQuizUpdateForm(quiz => quiz.filter(item => item.id !== quiz_id))
        } catch (e) {
            setReceivedError(e)
        }
    }

    const deleteCustomQuiz = async (quizId) => {
        try {
            const data = await request(`/quiz/remove/${quizId}`, 'POST', null, {
                'x-access-token': token
            })

            if (data.changed === 1) {

                let index = 0;
                const quiz = experience.quiz.filter(quiz_item => quiz_item.id !== quizId).map(quiz_item => ({
                    ...quiz_item,
                    index: quiz_item.client_id ? index++ : quiz_item.index,
                }))

                updateExperience({ ...experience, quiz });
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const changeQuizIndex = async (upperId, lowerId) => {
        try {
            const data = await request(`/experience/index_change/${upperId}/${lowerId}`, 'POST', { type: 'quiz' }, {
                'x-access-token': token
            })

            if (data.upper_changed === 1 && data.lower_changed === 1) {
                //if request success change name

                const quiz = experience.quiz.map(quiz_item => {
                    let index = quiz_item.index;

                    if (quiz_item.id === upperId) {
                        index = index - 1
                    }

                    if (quiz_item.id === lowerId) {
                        index = index + 1
                    }

                    return { ...quiz_item, index }
                })

                updateExperience({ ...experience, quiz })
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    const quizDisableChange = async (disabled, id, type) => {
        //disabled == 1 means quiz disabled, 0 = means enabled
        const disableStatus = !disabled
        try {
            const data = await request(`/quiz/${id}/client_lesson_disable/${clientId}`, 'POST', { 
                disabled: disableStatus,
                lessonId,
                experienceId: experience.id,
            }, {
                'x-access-token': token
            })


            if (data.changed === 1) {
                let quiz = experience.quiz;

                if (quiz?.length) {
                    quiz = quiz.map(
                        quiz_item => {
                            let disabled = quiz_item.disabled;

                            if (quiz_item.id === id) {
                                disabled = disableStatus ? 1 : 0
                            }
                            return { ...quiz_item, disabled }
                        }
                    )
                }

                updateExperience({ ...experience, quiz });

                /*  // we need this to update?
                if (role === 'admin') {
                    setDropdownExperience(
                        dropdown_experience => dropdown_experience.map(
                            item => {
                                if (item.quiz && item.quiz.length) {
                                    item.quiz = item.quiz.map(
                                        quiz_item => {
                                            if (quiz_item.id === id) {
                                                quiz_item.disabled = new_disabled ? 1 : 0
                                            }
                                            return quiz_item
                                        }
                                    )
                                }
                                return item
                            }
                        )
                    )
                }*/
            }
        } catch (e) {
            setReceivedError(e)
        }
    }

    return (
        <Row className="m-3">
            <Col>
                <h6 className="FormSubTitle">Default Quizzes</h6>
                {(quizData.quiz && quizData.quiz.length)
                    ?
                    <ListGroup className="ml-2 my-2">

                        {quizData.quiz.sort((a, b) => a.index - b.index).map((quiz_item, index) =>
                            <ListGroup.Item action key={quiz_item.id} className="ListItemStyled">
                                <span className="FormText">{quiz_item.name}</span>
                                {(quiz_item.disabled && quiz_item.disabled === 1)
                                    ? <Badge onClick={() => {
                                        quizDisableChange(1, quiz_item.id, 'default')
                                    }} variant="danger" className="ml-2">Disabled</Badge>
                                    : <Badge onClick={() => {
                                        quizDisableChange(0, quiz_item.id, 'default')
                                    }} variant="success" className="ml-2">Enabled</Badge>}
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                    : <span className="FormText">No quizzes</span>
                }
            </Col>
            <Col>

                <h6 className="FormSubTitle">Custom Quizzes</h6>
                <form className="mt-3 mb-2 FormBlock">
                    <Row className="d-flex">
                        <Col>
                            <input className="FormInputSmall" type="text" name="quiz_name"
                                placeholder="Enter quiz name.."
                                onChange={e => setQuizName(e.target.value)} />
                        </Col>
                        <Col className="align-self-end">
                            <button className="ElementButton" type="submit" variant="success" disabled={loading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    addCustomQuiz()
                                }}>
                                Add Quiz
                            </button>
                        </Col>
                    </Row>
                </form>

                {quizData.custom_quiz && quizData.custom_quiz.sort((a, b) => a.index - b.index).map((quiz_item, index, array) =>
                    <ListGroup.Item action key={quiz_item.id} className="ListItemStyled">
                        <div className="d-flex">
                            <div className="d-flex flex-column mr-3">
                                {array[index - 1] && <FaSortUp
                                    onClick={() => changeQuizIndex(quiz_item.id, array[index - 1].id)} />}
                                {array[index + 1] && <FaSortDown
                                    onClick={() => changeQuizIndex(array[index + 1].id, quiz_item.id)} />}
                            </div>
                            <span className="FormText">
                                <EditableSpan
                                    key={quiz_item.id + index}
                                    item={quiz_item}
                                    updateHandler={updateQuizHandler}
                                    fieldName={'name'}
                                    langCode=''
                                    textValue={quiz_item.name}
                                />
                            </span>
                            <div>
                                {quizUpdateForm.some(quizUpdateForm => quizUpdateForm.id === quiz_item.id && quizUpdateForm.updated === 1) &&
                                    <img src="/img/save_white.png" alt="" onClick={() => changeCustomQuiz(quiz_item.id)}
                                        className="CardBlockHederImgSmall mx-2 mt-1" />}
                                <Link to={{
                                    pathname: `/quiz/${quiz_item.id}`,
                                    state: { customLanguage: experience.language }
                                }}
                                    className="ml-2"><img src="/img/Edit.png" alt="" className="CardBlockHederImgSmall mx-3" /></Link>

                                <img src="/img/TrashB.png" alt="" onClick={() => {
                                    if (window.confirm('Delete this item?')) {
                                        deleteCustomQuiz(quiz_item.id)
                                    }
                                }} className="CardBlockHederImgSmall mx-2 mt-1" />

                                {(quiz_item.disabled && quiz_item.disabled === 1)
                                    ? <Badge onClick={() => {
                                        quizDisableChange(1, quiz_item.id, 'custom')
                                    }} variant="danger" className="ml-2">Disabled</Badge>
                                    : <Badge onClick={() => {
                                        quizDisableChange(0, quiz_item.id, 'custom')
                                    }} variant="success" className="ml-2">Enabled</Badge>}
                            </div>
                        </div>
                    </ListGroup.Item>
                )}
            </Col>
        </Row>
    )

}
